"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstance = getInstance;
const axios_1 = __importDefault(require("axios"));
const env_1 = require("../utils/env");
const either_1 = require("../types/either");
let axiosInstance = undefined;
function getInstance(flashToken) {
  if (axiosInstance) {
    if (!(axiosInstance.defaults.headers.Authorization === flashToken)) {
      axiosInstance.defaults.headers.Authorization = `Bearer ${flashToken}`;
    }
    return (0, either_1.right)(axiosInstance);
  }
  const baseUrl = (0, env_1.getCrudCoreBaseUrl)();
  if (baseUrl.isLeft()) {
    return (0, either_1.left)(baseUrl.value);
  }
  axiosInstance = axios_1.default.create({
    baseURL: baseUrl.value,
    headers: {
      Authorization: flashToken ? `Bearer ${flashToken}` : undefined
    }
  });
  return (0, either_1.right)(axiosInstance);
}